import resolveRequest from '../../utils/resolveRequest.js'
import axios from 'axios'
import { apiEndpoints, SERVER_PATH } from '../endpoints'

export default (id) => {
  const endpoint = `${apiEndpoints.machines}/${id}${apiEndpoints.disconnectionLogs}`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.get(URL, { withCredentials: true }))
}
